export default __webpack_public_path__ + "static/media/babykraken_only_450px-min.59efa6d4.png";